import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="api-dashboard-search-form"
export default class extends Controller {

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 250)
  }
}